// extracted by mini-css-extract-plugin
module.exports =  {"page-spinner":"index__page-spinner___QvyGk","pageSpinner":"index__page-spinner___QvyGk","spin":"index__spin___URMPr","small":"index__small___jqCKa"};